import React, { Component } from 'react';
import { connect } from 'react-redux';
import { shadowsArr } from './ShadowsConstants.jsx';
import ShadowsModalContainer from './ShadowsModalContainer.jsx';
import uuid from 'uuid';
import { showShadowsModal, setShadowsObj } from '../../../store/actions/shadows';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share';

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showShadowsModal: () => {
      dispatch(showShadowsModal());
    },
    setShadowsObj: (shadowObj) => {
      dispatch(setShadowsObj(shadowObj));
    }
  }
}

class Shadows extends Component {
  viewCSS(shadowObj) {
    const {
      showShadowsModal,
      setShadowsObj
    } = this.props;

    setShadowsObj(shadowObj);
    showShadowsModal();
    console.log(shadowObj);

  }


  renderShadow(shadowObj, index) {
    const {
      background,
      color,
      textShadowColor,
      text,
      fontFamily,
      shadowAngle,
      shadowLength
    } = shadowObj;

    let textShadowString = textShadowColor + ' 1px 1px,';

    let max = 30;
    if (shadowLength)
      max = shadowLength;
    for (let i = 0; i < max; i++) {
      if (shadowAngle === 'right')
        textShadowString += textShadowColor + ' ' + i + 'px ' + i + 'px,';
      else if (shadowAngle === 'left')
        textShadowString += textShadowColor + ' -' + i + 'px ' + i + 'px,';
    }
    textShadowString = textShadowString.replace(/,$/,"");

    let indexString = index.toString();
    if (index < 10) {
      indexString = '0' + indexString;
    }
    return (
      <div key={uuid.v4()}
        className="shadow-item-container">
        <div className="shadow-item-header">
          {indexString} - {fontFamily}
          <div className="shadow-item-copy-css"
            onClick={() => this.viewCSS(shadowObj)}>
            View css
          </div>
        </div>
        <div className="shadow-item"
          style={{
            background: background,
            color: color,
            fontFamily: fontFamily,
            textShadow: textShadowString,
            fontSize: '3em',
            paddingBottom: 60,
          }}>
          {text}
        </div>
        <div className="shadow-item-metadata">
          <div className="color-hex-circle"
            style={{
              background: background
            }}>&nbsp;</div> {background}
          <div className="color-hex-circle"
            style={{
              background: color
            }}>&nbsp;</div> {color}
          <div className="color-hex-circle"
            style={{
              background: textShadowColor
            }}>&nbsp;</div> {textShadowColor}
        </div>

      </div>
    )
  }


  render () {
    const {
      FacebookShareButton,
      TwitterShareButton,
    } = ShareButtons;

    const TwitterIcon = generateShareIcon('twitter');
    const FacebookIcon = generateShareIcon('facebook');

    return (
      <div>
        <div className="shadows-main-text">
          <div className="shadows-header">
            <div className="shadows-header-text">
              Trendy CSS Text Shadows
            </div>
            <div className="shadows-subheader-text">
              <p>
                Looking for inspiration to make your headlines stand out?
              </p>
              <p>
                Look no further! This free collection of beautiful long text shadows includes the fonts, colors, and CSS code to render it for your own site.
              </p>
              <p>
                Brought to you by <a href="/">Mixfont</a>, the modern font generator.
              </p>
              <FacebookShareButton
                url='https://www.mixfont.com/shadows'
                title='Trendy CSS Text Shadows from Mixfont'
                className="round-share-button">
                <FacebookIcon
                  size={32}
                  round />
              </FacebookShareButton>
              <TwitterShareButton
                url='https://www.mixfont.com/shadows'
                title='🎁🎉 Trendy CSS Text Shadows 🎈🎉'
                via='mixfont'
                hashtags={['webdesign', 'css3', 'css', 'ui']}
                className="round-share-button">
                <TwitterIcon
                  size={32}
                  round />
              </TwitterShareButton>
            </div>
          </div>
        </div>
        <ShadowsModalContainer />
        <div className="shadows-body">
          {shadowsArr.map((shadowObj, index) => {
            return this.renderShadow(shadowObj, index + 1);
          })}
        </div>
      </div>

    )
  }
}

export default Shadows = connect(undefined, mapDispatchToProps)(Shadows);



// WEBPACK FOOTER //
// ./src/pages/projects/shadows/Shadows.jsx